module.exports = __webpack_public_path__ + "/static/media/imagen.6f7187d6.jpg";